'use client';

import { useSyncExternalStore } from 'react';
const subscribe = () => () => {};
const getSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * `false` while the component tree is still being hydrated, `true` from the
 * first commit onwards.
 *
 * `getServerSnapshot` is used for the server render *and* the client's
 * hydration render, so both produce `false`; React re-renders with `true` right
 * after hydration. A component that mounts during a client-side navigation
 * never had a server render and gets `true` on its very first render, so
 * client-only inputs are not needlessly withheld there.
 */
export const useIsHydrated = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};